export default [
  {
    name: "inventories",
    meta: {
      title: "Inventories",
      sort: 4,
      authenticatable: true,
      description: "Inventories",
      icon: "mdi-format-list-numbered-rtl",
      permission: false,
      roles: ["admin", "dealer"],
    },
  },
];
